import axios from "axios";
import { fetchUserDetails, getToken } from "../../helpers"
import logger from "../../logger";
import jwtDecode from "jwt-decode";
import { getlocationInfoViaIp, getlocationViaCoords } from "../../components/GeoLocate/helper";
import { publishAppLoading } from "../Events/utils.events";
import pubsub from "@viewlift/pubsub"
let xApikey = window?.xApiKey
let apiBaseUrl = window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl;
let site = window.app_data.site.siteInternalName
let apiBaseCachedUrl = window?.app_data?.appcmsMain?.apiConfig?.apiBaseCachedUrl;

const getSubscriptionPlans = async (skipHba=false) => {
    try {
        let token = await getToken(token => { return token })
        let { userId, hba,mvpdProvider } = await fetchUserDetails()
        if (!userId) {
          let params = {
            site : site,
            device : "web_browser",
            monetizationModel : "SVOD",
            platform : "web_browser"
          }
          if(mvpdProvider) params.mvpdProvider = mvpdProvider
            let res = await axios.get(`${apiBaseUrl}/v3/plans`,
                {
                    params,
                    headers: {
                        ['x-api-key']: xApikey,
                        authorization: token
                    }
                })
            logger(res.data, "info")
            return res.data
        }else {
            let params = {
              site : site,
              userId : userId,
              device : "web_browser",
              monetizationModel : "SVOD",
              platform : "web_browser"
            }
            if(mvpdProvider) params.mvpdProvider = mvpdProvider
            if (hba?.enabled && !skipHba) {
              let locationCoords = JSON.parse(localStorage.getItem("locationCoords"))
              let countryCode = locationCoords?.countryisocode
              let latitude = locationCoords?.latitude
              let longitude = locationCoords?.longitude
              params.countryCode = countryCode
              params.latitude = latitude
              params.longitude = longitude
            }
            let res = await axios.get(`${apiBaseUrl}/v3/plans`,
            {
              params: params,
              headers: {
                ['x-api-key']: xApikey,
                authorization : token
              }
            })
            return res.data
          }
    }
    catch (e) {
      logger(e, "error")
        return null
    }
}

const getPlansById = async (ids,isQueryPlanIds=false,isAssociatedPlans=false) => {
    try {
        let token = await getToken(token => { return token })
        let { userId, mvpdProvider } = await fetchUserDetails()
        let plansApiUrl = `${apiBaseUrl}/v3/plans`
        let params = { 
          site: site,
          userId: userId || '',
          ids: ids,
          device: 'web_browser',
        }
        if(site === 'caliente' && !userId) {
          let countryCode = jwtDecode(token)?.countryCode;
          plansApiUrl = `${apiBaseCachedUrl}/v3/plans`
          params["store_countryCode"] = countryCode
        }
          if(mvpdProvider) params.mvpdProvider = mvpdProvider
          if (isQueryPlanIds || (isAssociatedPlans && mvpdProvider)) {
            params.allPlans = true
          }
        let res = await axios({
            method: 'GET',
            url: plansApiUrl,
            params,
            headers: {
                Authorization: token,
                'x-api-key': xApikey
            }
        })
        return res?.data
    } catch (e) {
        logger(e, "error")
        //   pubsub.publish('isLoading', false)
    }
}

const getPlansByIdLocation = async (ids, locationObj, isQueryPlanIds = false, ) => {
  try {
    let token = await getToken(token => { return token })
    let latitude =  locationObj?.latitude  
    let longitude =  locationObj?.longitude 
    let { userId, mvpdProvider } = await fetchUserDetails()
    let params = {
      site: site,
      userId: userId,
      ids: ids,
      device: 'web_browser',
      visible: true,
      latitude,
      longitude
    }
    if (mvpdProvider) params.mvpdProvider = mvpdProvider
    if (isQueryPlanIds) {
      params.allPlans = true
    }
    let res = await axios({
      method: 'GET',
      url: `${apiBaseUrl}/v3/plans`,
      params,
      headers: {
        Authorization: token,
        'x-api-key': xApikey
      }
    })
    return res?.data
  } catch (e) {
    console.error(e)
    pubsub.publish('isLoading', false)
  }
}


const getUserLocation = () => {
  let userResponded = false;
  return new Promise((resolve,reject) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          localStorage.removeItem('locationCoords')
          userResponded = true;
          let coordinates = position.coords
          let res = coordinates?.latitude && coordinates?.longitude && 
          await getlocationViaCoords(coordinates.latitude, coordinates.longitude)
            let byCoordinates = res.data.lookupMode === "coordinates" ? true : false
            const locationObj = {postalCode: res.data.postalcode, latitude: coordinates.latitude, longitude: coordinates.longitude, countryisocode: res.data.countryisocode, byCoordinates: byCoordinates, origip: res.data.origip}
            sessionStorage.setItem('locationCoords', JSON.stringify(locationObj))
            sessionStorage.setItem('zipCode',res.data.postalcode)
            resolve(locationObj)
        },
        async (error) => {
          userResponded = true;
          switch (error.code) {
            case error.PERMISSION_DENIED:
                localStorage.removeItem('locationCoords')
                let res = await getlocationInfoViaIp()
                let byCoordinates = res.data.lookupMode === "coordinates" ? true : false
                const locationObj = {postalCode: res.data.postalcode, countryisocode: res.data.countryisocode, byCoordinates: byCoordinates, origip: res.data.origip,longitude : res.data.longitude}
                sessionStorage.setItem('locationCoords', JSON.stringify(locationObj))
                sessionStorage.setItem('zipCode',res.data.postalcode)
                resolve(locationObj)
                break;
            case error.POSITION_UNAVAILABLE:
              reject("Location information is unavailable.")
              break;
            case error.TIMEOUT:
              reject("The request to get user location timed out.")
              break;
            default:
              reject("An unknown error occurred.")
              break;
          }
        }
      );
      setTimeout(() => {
        if (!userResponded) {
          localStorage.removeItem('locationCoords')
          getlocationInfoViaIp().then((res) => {
            let byCoordinates = res.data.lookupMode === "coordinates" ? true : false
            const locationObj = {postalCode: res?.data?.postalcode, latitude:res?.data?.latitude, longitude: res?.data?.longitude, countryisocode: res?.data?.countryisocode, origip: res?.data?.origip}
            sessionStorage.setItem('locationCoords', JSON.stringify(locationObj))
            sessionStorage.setItem('zipCode',res.data.postalcode)
            resolve(locationObj)
          }).catch(() => {
            // publish Error to show
            publishAppLoading(false)
          })
          console.log("User denied the request for Geolocation.");
        }
      }, 12000)
    } else {
      reject("Geolocation is not supported by this browser.")
    }
  })
};

export {getSubscriptionPlans, getPlansById, getUserLocation, getPlansByIdLocation}
